module.exports = __webpack_public_path__ + "static/media/dark_en.7abdfb1d.svg";